import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import {
  FDImage,
  FDPaper, FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';

const RequestChurnWithConcessionsIntroStepLayout = () => {
  const {
    onSubmit,
    saving,
    resource,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  return (
    <>
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} spacing={2}>
          {resource.withRelationship(fr.relationships.image.name,
            (rel) => (
              <FDImage alt={''} src={rel.link('related').url()} width={'200px'} rounded={false} />
            ),
            () => null)}
          <MetaControlField
            attr={'title'}
          />
          <MetaControlField
            attr={'subtitle'}
          />
          <FDPaper color={'info'} padding={400}>
            <FDStack direction={'column'} spacing={2}>
              <MetaControlField
                attr={'bodyTitle'}
              />
              <MetaControlField
                attr={'body'}
              />
            </FDStack>
          </FDPaper>
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDStack direction="row" spacing={2} flex={1} justifyContent={'center'} wrap>
          {resource.meta().canPost() ? <FDSecondaryActionButton flex={1} loading={saving} label={resource.attr('primaryActionLabel')} onClick={onSubmit} /> : null}
          <FDPrimaryActionButton flex={1} loading={saving} label={resource.attr('secondaryActionLabel')} onClick={clearModalCollection} />
        </FDStack>
      </DialogActions>
    </>
  );
};

RequestChurnWithConcessionsIntroStepLayout.defaultProps = {
};

RequestChurnWithConcessionsIntroStepLayout.propTypes = {
};

export default RequestChurnWithConcessionsIntroStepLayout;
